import React from 'react';
import ListView, {ListViewProps} from './ListView';
import TableHead from './TableHead';
import {useListContext} from './ListContext';

const SimpleList = (props: ListViewProps) => {
  const {children, ...rest} = props;
  const {list} = useListContext();

  return (
    <ListView
      tableHead={React.createElement(
        TableHead,
        {
          bulkOptions: false,
          order: 'asc',
          orderBy: 'id',
          rowCount: list.length,
          onRequestSort: () => {},
          ids: list.map((item) => item.name)
        },
        children
      )}
      {...rest}
    >
      {children}
    </ListView>
  );
};

export default SimpleList;
